import { useEffect, useState } from "react";
import { API } from "@/lib/brand";
import PostCard from "./PostCard";

/**
 * Shows up to `limit` published posts in the same category as `slug`,
 * excluding the current post. Falls back to the site's most-recent posts
 * if the category has fewer than `limit` other entries.
 */
export default function RelatedPosts({ slug, limit = 3 }) {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`${API}/journal/posts/${slug}/related?limit=${limit}`);
        const data = res.ok ? await res.json() : [];
        if (!cancelled) setPosts(Array.isArray(data) ? data : []);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [slug, limit]);

  if (loading) return null;
  if (posts.length === 0) return null;

  return (
    <section className="mt-16 pt-12 border-t hairline" data-testid="related-posts">
      <div className="eyebrow mb-2">Keep reading</div>
      <h2 className="font-display text-2xl md:text-3xl text-ink leading-tight mb-6">
        More from the Journal
      </h2>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {posts.map((p) => (
          <PostCard key={p.id} post={p} testId={`related-post-${p.slug}`} />
        ))}
      </div>
    </section>
  );
}
